import React, { useEffect, useState } from "react";
import Navbar from "../sections/common/Navbar";
import Banner from "../sections/home/Banner";
import ExploreProperty from "../sections/home/ExploreProperty";
import DiscoverProperty from "../sections/home/DiscoverProperty";
import LatestProperties from "../sections/home/LatestProperties";
import Testimonial from "../sections/common/Testimonial";
import Featured from "../sections/home/Featured";
import Choose from "../sections/home/ChooseUs";
import Blog from "../sections/home/Blog";
import Find from "../sections/home/Find";
import Footer from "../sections/common/Footer";
import Stripe from "../sections/home/Stripe";
import { fetchHomeDetails } from "../Redux/slice/homeSlice";
import { useDispatch, useSelector } from "react-redux";
import { categoryListApi } from "../apis/propertylisting/propertyListApi";

const Home = () => {
  const dispatch = useDispatch();
  const homeData = useSelector((state) => state?.home?.data);
  const [categoryData, setCategoryData] = useState([])

  useEffect(() => {
    dispatch(fetchHomeDetails());
  }, []);

  useEffect(() => {
    const fetchCategoryList = async () => {
      const response = await categoryListApi();
      const categoryList = response?.data?.data;
      setCategoryData(categoryList);
    };

    fetchCategoryList();
  }, []);

  return (
    <>
      <Navbar />
      <Banner
        categoryData={categoryData && categoryData.category}
        locationData={categoryData && categoryData.location}
      />
      <Stripe />
      <ExploreProperty categoryData={homeData && homeData?.category} />
      <DiscoverProperty locationData={homeData && homeData?.location} />
      <LatestProperties
        latestProperty={homeData && homeData?.latestProperty}
        rent={homeData && homeData?.rent}
        sell={homeData && homeData?.sell}
      />
      <Find />
      <Featured featuredProperty={homeData && homeData?.featured} />
      <Choose />
      <Blog blog={homeData && homeData?.blog} />
      <Testimonial testimonial={homeData && homeData?.testimonial} />
      <Footer />
    </>
  );
};

export default Home;
